const invalidNumber = -1

export default {
  modelsLibrary: [],
  modelsLibraryTags: [],
  libraryEntry: {
    Categories: [],
    DisplayName: '',
    Item: {
      Id: -1,
      URL_Reference: '',
    },
    Tags: [],
    ThumbnailUrl: '',
  },
  defaultLibraryCategory: {
    DisplayName: 'New Category',
    CategoryOrder: invalidNumber,
    StateId: 0,
    StateName: 'Under Construction',
  },
  libraryPublicCategories: {
    Categories: [],
    CategoryOrder: [],
  },
  libraryCategories: {
    Categories: [],
    CategoryOrder: [],
  },
  libraryCategoriesUsage: {
    usage: [],
    usageMap: {},
  },
  libraryCategoryStates: {
    States: [],
  },
  securityCertificates: [],
  libraryReferenceAssets: [],
  defaultLibraryCategoryState: null,
  currentPage: 1,
  itemsPerPage: 50,
  totalPages: 1,
  totalRows: 0,
}
